import { CAMPAIGN_FORM_TITLE } from '~/constants/campaign'
import { useFormContext, Controller } from 'react-hook-form'
import { ReviewSection, ReviewTarget, FormatVersion, CampaignCategory } from '~/generated/graphql'
import { TextFieldWithRemainingLength } from '~/components/TextFieldWithRemainingLength'
import { CampaignInputComponent, CampaignInputComponentProps } from './CampaignInputComponent'
import { z } from 'zod'
import { ValidationErrorMessage } from '~/components/common/ValidationErrorMessage'
import { categoryField } from '~/features/campaign_input/type'

export const sponsorServiceNameSchemaFields = {
  name: z
    .string({
      required_error: '必須項目です',
    })
    .min(1, {
      message: '必須項目です。',
    }),
  ...categoryField,
}
export const sponsorServiceNameSchema = z.object(sponsorServiceNameSchemaFields)

const getMaxLength = () => 70

// キャンペーン名長さの制限のためのジェネリクス関数
export const validateCampaignNameLength = (data: z.infer<typeof sponsorServiceNameSchema>, ctx: z.RefinementCtx) => {
  const length = getMaxLength()
  if (data.name && data.name.length > length) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ['name'],
      message: '文字数が上限に達しました。',
    })
    return z.NEVER
  }
  return data
}
type Props = CampaignInputComponentProps

export const SponsorServiceName = ({ description, tooltip }: Props) => {
  const { control, watch } = useFormContext<z.infer<typeof sponsorServiceNameSchema>>()
  const category = watch('category')

  return (
    <CampaignInputComponent
      title={CAMPAIGN_FORM_TITLE.name}
      required={true}
      description={description}
      review={{
        section: ReviewSection.Campaign,
        targets: [ReviewTarget.CampaignName, ReviewTarget.LegalCampaignName],
      }}
      compatibleFormatVersions={[FormatVersion.V4Campaign]}
      tooltip={tooltip}
    >
      <Controller
        name={'name'}
        control={control}
        render={({ field: { ref, ...field }, fieldState }) => (
          <TextFieldWithRemainingLength
            fullWidth
            placeholder={
              '例）' +
              (category === CampaignCategory.Product
                ? '《冷凍》チーズケーキ（5号）'
                : '海鮮コース全 10品 2時間飲み放題付き')
            }
            multiline
            rows={2}
            maxLength={getMaxLength()}
            error={!!fieldState.error}
            helperText={<ValidationErrorMessage error={fieldState.error?.message} />}
            inputRef={ref}
            {...field}
          />
        )}
      />
    </CampaignInputComponent>
  )
}
